export default __webpack_public_path__ + "static/media/Act4_Myyja.4bcb65fd.svg";